import { ProductSelection, ProductSelectionResource } from './ProductSelection';

export const transformToProductSelection = (resource: ProductSelectionResource): ProductSelection => ({
    name: resource.name,
    syliusId: resource.sylius_id,
});
